export enum LeftActiveAdminPageEnum {
  Companies = "Companies",
  Settings = "Settings",
  AuditLogs = "AuditLogs",
  ProviderLogs = "ProviderLogs",
  EtlJobLogs = "EtlJobLogs",
  Processes = "Processes",
  MessagingLogs = "MessagingLogs",
  ReportManagement = "ReportManagement",
  MapCacheStat = "MapCacheStat",
  Tools = "Tools",
  SupplierQuarantines = "SupplierQuarantines",
  AiConversations = "AiConversations",
  AiConversationStats = "AiConversationStats",
  BackupManagement = "BackupManagement",
}
